<template>
  <Dialog
    :title="type === 'add' ? '新增角色' : '修改角色'"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="cancel"
  >
    <el-form ref="formRef" :model="form" label-width="100px" :rules="rules">
      <el-form-item label="角色名称" prop="roleName">
        <el-input
          v-model.trim="form.roleName"
          placeholder="请输入角色名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色代码" prop="roleKey">
        <el-input
          v-model.trim="form.roleKey"
          placeholder="请输入角色代码"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色排序" prop="roleSort">
        <el-input-number
          v-model="form.roleSort"
          :min="0"
          controls-position="right"
          placeholder="请输入角色排序"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button plain round size="small" @click="cancel">取 消</el-button>
      <el-button plain round size="small"
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>

<script>
import { roleSave, roleUpdate, roleInfo } from "@/api/system/role";

const defaultForm = () => ({
  roleKey: "",
  roleName: "",
  roleSort: 0
});

export default {
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      type: "add",
      form: defaultForm(),
      rules: {
        roleKey: [
          { required: true, message: "请输入角色代码", trigger: "blur" }
        ],
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" }
        ],
        roleSort: [
          { required: true, message: "请输入角色排序", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    async open(type, row = {}) {
      this.type = type;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
      if (type === "edit") {
        try {
          const result = await roleInfo(row.roleId);
          const data = result.data || row;
          this.form = {
            roleId: data.roleId || row.roleId || "",
            roleKey: data.roleKey || "",
            roleName: data.roleName || "",
            roleSort:
              data.roleSort != null && data.roleSort !== ""
                ? Number(data.roleSort)
                : 0
          };
        } catch (e) {
          this.cancel();
        }
      } else {
        this.form = defaultForm();
      }
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return false;
      }
      this.submitLoading = true;
      try {
        const result =
          this.type === "edit"
            ? await roleUpdate(this.form)
            : await roleSave(this.form);

        this.$message.success(
          this.type === "edit" ? "编辑成功！" : "保存成功！"
        );
        this.cancel();
        this.$emit("success");
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.form = defaultForm();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/system/Role/RoleForm.vue